export * from './getGivingSummary';
export * from './getGivingPayments';
export * from './getGivingMetrics';
export * from './getGivingRetention';
export * from './getSubscriberStats';
export * from './getDonationPayouts';
export * from './getPayoutsSummary';
export * from './getTransactionsSummary';
export * from './getPayoutTransactions';
export * from './getPayoutTransactionsReport';
export * from './getPayoutById';
export * from './getImpactReports';
export * from './generateImpactReport';
export * from './generateMonthlyPerformanceReport';
export * from './deleteImpactReport';

export function payoutsMapper(transfer) {
  return {
    id: transfer.stripe_payout_id,
    date: transfer.date,
    grossAmount: transfer.gross_amount,
    feeAmount: transfer.fee_amount,
    netAmount: transfer.net_amount,
    status: transfer.status,
    bank: {
      name: transfer.bank_account.bank_name,
      lastFourDigits: transfer.bank_account.last4,
      currency: transfer.bank_account.currency,
    },
  };
}

export function payoutTransactionMapper(transaction) {
  return {
    id: transaction.id,
    type: transaction.type,
    label: transaction.label,
    description: transaction.description,
    userName: transaction.user_name,
    userId: transaction.user_id,
    fundName: transaction.fund_name,
    date: transaction.date,
    amount: transaction.amount,
    netAmount: transaction.net_amount,
  };
}
